import { render, staticRenderFns } from "./AccountDescription.pug?vue&type=template&id=7f091506&scoped=true&lang=pug&"
import script from "./AccountDescription.vue?vue&type=script&lang=js&"
export * from "./AccountDescription.vue?vue&type=script&lang=js&"
import style0 from "./AccountDescription.vue?vue&type=style&index=0&id=7f091506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f091506",
  null
  
)

export default component.exports